import React from 'react';

import Button, { GoShipButtonProps } from '@/components/Button';

const CallToAction = React.forwardRef<HTMLDivElement, GoShipButtonProps>(
  ({ children, ...props }, ref) => (
    <div ref={ref} className="flex md:justify-end items-center">
      <Button className="flex-grow md:flex-grow-0" variant="solid" {...props}>
        {children}
      </Button>
    </div>
  ),
);

export default CallToAction;
